import React, { useState } from "react";
import "../../../../../styles/ambassadorChallenge/noActiveChallenge.scss";
import CreateChallengeModal from "./CreateChallengeModal";

const NoActiveChallenge: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="no-challenge">
      <div className="icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 0 0 2-2V7a2 2 
            0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2z"
          />
        </svg>
      </div>

      <h3 className="title">No Active Challenge</h3>
      <p className="text">
        There is currently no active challenge running. Create a new challenge
        to engage your community and reward top ambassadors.
      </p>

      <button className="launch-btn" onClick={() => setOpen(true)}>
        + Launch new challenge
      </button>

      {open && <CreateChallengeModal onClose={() => setOpen(false)} />}
    </div>
  );
};

export default NoActiveChallenge;
